<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';

    const props = withDefaults(
        defineProps<{
            totalRecords: number;
            label?: string;
        }>(),
        {
            label: undefined,
        }
    );
</script>
<template>
    <div class="flex w-full flex-col justify-center h-22 p-3 pl-6">
        <span class="text-overline-sm text-gray-dark">
            {{ label ?? __('interactions-table-total-interactions') }}
        </span>
        <span class="heading-md-light text-gray-dark mt-2">
            {{ props.totalRecords }}
        </span>
    </div>
</template>
